const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const Quad = require("./Quad");
const QuadUtil = require("../util/QuadUtil");
const Sounds = require("../util/Sounds");
const AssetsUtil = require("../util/AssetsUtil");
const styles = require("./styles/ModalClose.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component, function(props, vaultState) {
		return {connected: vaultState.connected};
	});
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ModalClose",

		propTypes: {
			onClick: PT.func,
			extraClassName: PT.string,
			noSounds: PT.bool,
			modalType: PT.string,

			// Injected by HOCs
			connected: PT.bool.isRequired,
		},

		onClick: function() {
			if (!this.props.noSounds) {
				Sounds.playSound("x-button");
			}
			if (this.props.onClick) {
				this.props.onClick();
			}
		},

		render: function() {
			// baNoDrag class is used to prevent dragging by the close button on
			// draggable modals (see Problem.jsx and Solution.jsx).
			let className =
				(this.props.connected ? styles.main : styles.fallback) + " baNoDrag";
			if (this.props.extraClassName) {
				className += " " + this.props.extraClassName;
			}
			const buttonIconType =
				this.props.modalType === "demo" ? "close-demo" : "close";
			const xImg = this.props.connected ? (
				<img
					className={styles.x}
					src={AssetsUtil.getTrainerIconButton(buttonIconType)}
				/>
			) : null;
			return (
				<div className={className} onClick={this.onClick}>
					<Quad
						quad={QuadUtil.quadTable.closeButton}
						backgroundClass={styles.bg}
						borderClass={styles.border}
						borderWidths={[0.2, 0, 0, 0.2]}
						borderUnits={"rem"}
						shadowOffset={3}
						shadowOpacity={0.4}
					/>
					{xImg}
				</div>
			);
		},
	})
);
